var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.storageLocation.isActive === 'false')?_c('span',[_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v("Inactive")])],1):_c('span',[_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Active")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }